module.exports = __webpack_public_path__ + "img/module-detail.0e4cb9ba.png";